import { useContext } from "react";
import { Link } from "react-router-dom";
import { ModeContext } from "../../context/mode.context";
import "./country-card.component.scss";

const CountryCard = ({ country }) => {
  const { name, population, region, capital, flag } = country;
  const { mode } = useContext(ModeContext);
  return (
    <div className={`countrycard ${mode ? ` countrycard-dark` : ``}`}>
      <div className="countrycard__flag">
        <img src={flag} alt={`${name}`} className="countrycard__flag--img" />
      </div>
      <div
        className={`countrycard__data ${mode ? ` countrycard-dark__data` : ``}`}
      >
        <Link
          className={`countrycard__data--name ${
            mode ? ` countrycard-dark__data--name` : ``
          }`}
          to={`countries/${name}`}
        >
          {name}
        </Link>
        <p className="countrycard__data--item">
          <span>Population:</span>
          {population}
        </p>
        <p className="countrycard__data--item">
          <span>Region:</span>
          {region}
        </p>
        <p className="countrycard__data--item">
          <span>Capital:</span>
          {capital}
        </p>
      </div>
    </div>
  );
};

export default CountryCard;
